import classNames from "classnames";
import { Link } from "gatsby";
import React, { ReactNode } from "react";
import { FaArrowRight } from "react-icons/fa";

interface Props {
  thumbnail: string;
  summary: string;
  title: string;
  className?: string;
  type: "blog" | "work";
  slug: string;
  imageClassName?: string;
}

const ResourceCard: React.FC<Props> = ({
  summary,
  thumbnail,
  title,
  className,
  type,
  slug,
  imageClassName,
}) => {
  return (
    <div
      className={classNames(
        "lg:h-68 flex w-full flex-col items-center gap-5 rounded-3xl bg-white p-5 lg:flex-row lg:gap-7 lg:p-7",
        className
      )}
    >
      <img
        src={thumbnail}
        alt={title}
        className={classNames(
          "h-52 w-full shrink-0 rounded-3xl object-cover lg:h-52 lg:w-56",
          imageClassName
        )}
      />
      <div className="flex w-full flex-col gap-4 text-left">
        <p className="leading-7.5 text-green-dark text-xl font-semibold">
          {title}
        </p>
        {summary && (
          <p className="text-sm text-gray-700">
            {summary?.length > 100
              ? `${summary.substring(0, 100)}...`
              : summary}
          </p>
        )}

        <Link to={`/blogs/${slug}`}>
          {/* @ts-ignore */}
          <span className="flex items-center gap-10 text-primary">
            View Article
            {/* @ts-ignore */}
            <FaArrowRight />
          </span>
        </Link>
      </div>
    </div>
  );
};

export default ResourceCard;
